import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const FavoritesContext = createContext(null);

export const useFavorites = () => useContext(FavoritesContext);

export const FavoritesProvider = ({ children }) => {
    const [favorites, setFavorites] = useState(() => {
        const saved = localStorage.getItem('ecommerce_favorites');
        return saved ? JSON.parse(saved) : [];
    });

    useEffect(() => {
        localStorage.setItem('ecommerce_favorites', JSON.stringify(favorites));
    }, [favorites]);

    // Normalizar producto: asegurar que tenga un ID único
    const getNormalizedId = (product) => {
        return product.id || product.idProducto;
    };

    const addToFavorites = useCallback((product) => {
        setFavorites(prev => {
            const normalizedId = getNormalizedId(product);
            // No agregar duplicados
            if (prev.some(fav => getNormalizedId(fav) === normalizedId)) {
                return prev;
            }
            return [...prev, { ...product, id: normalizedId }];
        });
    }, []);

    const removeFromFavorites = useCallback((productId) => {
        setFavorites(prev => prev.filter(fav => getNormalizedId(fav) !== productId));
    }, []);

    const toggleFavorite = useCallback((product) => {
        setFavorites(prev => {
            const normalizedId = getNormalizedId(product);
            const exists = prev.some(fav => getNormalizedId(fav) === normalizedId);
            if (exists) {
                return prev.filter(fav => getNormalizedId(fav) !== normalizedId);
            }
            return [...prev, { ...product, id: normalizedId }];
        });
    }, []);

    const isFavorite = useCallback((productId) => {
        return favorites.some(fav => getNormalizedId(fav) === productId);
    }, [favorites]);

    const value = {
        favorites,
        setFavorites,
        addToFavorites,
        removeFromFavorites,
        toggleFavorite,
        isFavorite
    };

    return (
        <FavoritesContext.Provider value={value}>
            {children}
        </FavoritesContext.Provider>
    );
};
